import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "local-development"
    }}>{`Local development`}</h1>
    <p>{`If you want to add new functionality or fix a bug in `}<inlineCode parentName="p">{`ts-auto-mock`}</inlineCode>{` you are in the right place.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`Node.js >= 10`}</li>
      <li parentName="ul">{`NPM`}</li>
      <li parentName="ul">{`A local clone of the repo`}</li>
    </ul>
    <h2 {...{
      "id": "install-local-dependencies"
    }}>{`Install local dependencies`}</h2>
    <p>{`Make sure you are in the project root folder`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install
`}</code></pre>
    <h2 {...{
      "id": "build-the-transformer"
    }}>{`Build the transformer`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm run build
`}</code></pre>
    <h2 {...{
      "id": "make-a-change"
    }}>{`Make a change`}</h2>
    <p><inlineCode parentName="p">{`ts-auto-mock`}</inlineCode>{` consists of multiple modules, each of them has a different meaning and depending on what you are editing you can re-build each module individually`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`transformer`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`repository`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`extension`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`merge`}</inlineCode></li>
    </ul>
    <p>{`If you are editing the transformer:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run build:transformer
`}</code></pre>
    <p>{`If you are editing anything else:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run build:modules
`}</code></pre>
    <h2 {...{
      "id": "test-your-changes"
    }}>{`Test your changes`}</h2>
    <p>{`There are 2 ways to test the effect of your changes`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Use the existing test system`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Add a test`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run all the tests`}</p>
            <pre parentName="li"><code parentName="pre" {...{}}>{`npm run test
// or use npm run test:transformer if you are just editing the transformer
`}</code></pre>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use the playground`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Open the file `}<a parentName="p" {...{
                "href": "https://github.com/Typescript-TDD/ts-auto-mock/blob/master/test/playground/playground.test.ts"
              }}>{`playground.test.ts`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Make your changes`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run test playground to see the test pass`}</p>
            <pre parentName="li"><code parentName="pre" {...{}}>{`npm run test:playground
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run build playground to see the emitted JS code in the corresponding `}<inlineCode parentName="p">{`playground.test.js`}</inlineCode>{`-file`}</p>
            <pre parentName="li"><code parentName="pre" {...{}}>{`npm run build:playground
`}</code></pre>
          </li>
        </ul>
      </li>
    </ul>
    <p>{`That's it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      